import { restApi } from '../../services/api';
import { BrandSplitSettings, BrandSplitSettingsDTO } from './brandSplitSettings.types';

const PATH = 'brand-split-settings';
export const brandSplitSettingsRepository = {
  getBrandConfig: () => restApi.get<BrandSplitSettingsDTO[]>(`${PATH}/brand-config`),
  list: () => restApi.get<BrandSplitSettingsDTO[]>(PATH),
  updateOrCreate: (body: BrandSplitSettings[]) =>
    restApi.patch<BrandSplitSettingsDTO[]>(PATH, body),
};
